import React from 'react';
import { useTranslation } from 'react-i18next';

// Context
import { useCompareContext } from '@/context/compare';

// Controller
import { toggleExpandedCompareTray } from '@/braun/Controllers/CompareTrayController';

const CompareActions = () => {
  const { t } = useTranslation();
  const [, { clearCompare, openCompare }] = useCompareContext();

  return (
    <div className='bra-compareTray__actions'>
      <button
        type='button'
        className='bra-btn bra-btn--compare bra-btn--rounded js-gtm-comparison-tool-loaded'
        onClick={() => {
          toggleExpandedCompareTray();
          openCompare(true);
        }}
      >
        {t('listing:listing.compare.cta.label')}
      </button>
      <button
        type='button'
        className='bra-btn bra-btn--clearAll bra-btn--rounded bra-btn--bordered'
        onClick={clearCompare}
      >
        {t('listing:listing.compare.clear.label')}
      </button>
    </div>
  );
};

export default CompareActions;
